const styles = {
  default: {
    backgroundSize: '50px',
    backgroundPosition: 'center center',
    backgroundRepeat: 'no-repeat',
    height: 50,
    width: 50,
  },
};

export default styles;
